import axios from 'axios';
import { destroySessionManager } from '../utils/sessionManager';
// Use environment variable with fallback
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

console.log('🔧 API Configuration:');
console.log('  - REACT_APP_API_URL:', process.env.REACT_APP_API_URL);
console.log('  - Using API_BASE_URL:', API_BASE_URL);

const api = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  console.log('📤 Making request to:', `${config.baseURL || ''}${config.url || ''}`);
  console.log('📤 Token from localStorage:', token ? 'EXISTS' : 'MISSING');
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    console.log('📤 Added Authorization header');
  } else {
    console.log('⚠️ NO TOKEN - Request will fail!');
  }
  
  return config;
});

api.interceptors.response.use(
  (response) => {
    console.log('✅ Response received:', response.status, response.data);
    return response;
  },
(error) => {
    console.log('❌ Request failed:', error.response?.status, error.response?.data);
    console.log('❌ Full error:', error.message);
    
    if (error.response?.status === 401) {
      console.log('🔒 Unauthorized - clearing auth and redirecting to login');
      destroySessionManager(); // Stop session monitoring
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('isAuthenticated');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const clientApi = {
  getAll: () => api.get('/clients'),
  getById: (id: string) => api.get(`/clients/${id}`),
  create: (data: any) => api.post('/clients', data),
  update: (id: string, data: any) => api.put(`/clients/${id}`, data),
  delete: (id: string) => api.delete(`/clients/${id}`),
};

export const commentApi = {
  getByClient: (clientId: string) => api.get(`/comments/client/${clientId}`),
  create: (data: { clientId: string; content: string }) => api.post('/comments', data),
  delete: (id: string) => api.delete(`/comments/${id}`),
};

export const filingApi = {
  getAll: () => api.get('/filings'),
  getById: (id: string) => api.get(`/filings/${id}`),
  updateStatus: (id: string, data: { 
    status: string; 
    filedDate?: string; 
    statusDate?: string; 
    notes?: string; 
  }) => api.patch(`/filings/${id}/status`, data),
  getHistory: (id: string) => api.get(`/filings/${id}/history`),
  delete: (id: string) => api.delete(`/filings/${id}`),
  getStats: () => api.get('/filings/stats'),
  updateSentToClient: (id: string, sentToClient: boolean) => api.patch(`/filings/${id}/sent-to-client`, { sentToClient }),
};

export const emailApi = {
  sendTest: (email: string) => api.post('/test-email', { email }),
  triggerReminders: () => api.post('/email/trigger-reminders'),
};

export const userApi = {
  getAll: () => api.get('/users'),
  getEmployees: () => api.get('/users/employees'),
};

export default api;